export default {
  onAppLaunch(vm) {
    this.vm = vm
    // Line連結帳戶confirm
    this.vm.$helper.lineConnectAccountConfirm = (config = {}) => {
      const {
        beforeApply,
      } = config
      this.vm.$apopup.base({
        title: this.vm.i18n('line.action.connect-account'),
        width: '450px',
        bodySlot: () => import('modules/line/components/connectConfirm.vue'),
        applyLabel: this.vm.i18n('action.continue'),
        applyCallback: async () => {
          if(typeof beforeApply === 'function') {
            beforeApply()
          }
          await this.vm.$nextTick()
          this.vm.$oauth.login(this.getLineOauthLoginConfig())
        },
      })
    }

    // Line取消連結帳戶confirm
    this.vm.$helper.lineDisconnectAccountConfirm = (config = {}) => {
      const {
        beforeApply,
        applyCallback,
      } = config
      this.vm.$apopup.base({
        title: this.vm.i18n('line.action.disconnect-account'),
        content: this.vm.i18n('confirm.execute'),
        applyCallback: async () => {
          if(typeof beforeApply === 'function') beforeApply()
          await this.vm.$nextTick()
          if(typeof applyCallback === 'function') applyCallback()
        },
      })
    }
  },
  getLineOauthLoginConfig() {
    const oauth = this.vm.$store.getters['base/oauth']
    if(!oauth) return null
    const host = `${window.location.origin}`
    const href = this.vm.$router.resolve({
      name: 'member.line-connect-return',
    }).href
    const config = {
      service: 'line',
      clientKey: oauth.line.client,
      redirectUri: `${host}${href}`,
      metaData: {
        originPath: this.vm.$route.fullPath,
      },
    }
    return config
  },
}